import * as React from "react";
import { FunctionComponent } from "react";
import { quickscan } from "../reducer/quickscan";
import { Actions, Props } from "../types";
import { getEmptyQuickscanState, QuickscanDataContext } from "../context/QuickscanDataContext";
import { SettingsContext } from "../context/SettingsContext";

export const QuickscanProvider: FunctionComponent = (props: Props.QuickscanProvider) => {

    const [quickscanDataState, quickscanDataDispatch] = React.useReducer(quickscan, getEmptyQuickscanState());

    return (
        <QuickscanDataContext.Provider value={[quickscanDataState, quickscanDataDispatch]}>
            {props.children}
        </QuickscanDataContext.Provider>
    );

}
